import { render, staticRenderFns } from "./menu-filter.vue?vue&type=template&id=0fff44f0&"
import script from "./menu-filter.vue?vue&type=script&lang=js&"
export * from "./menu-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports